import { render, staticRenderFns } from "./RepositoryConstraintUpdate.vue?vue&type=template&id=c48d8836&"
import script from "./RepositoryConstraintUpdate.vue?vue&type=script&lang=js&"
export * from "./RepositoryConstraintUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports